import { render, staticRenderFns } from "./SavedQueriesModal.vue?vue&type=template&id=0ca6e384&"
import script from "./SavedQueriesModal.vue?vue&type=script&lang=js&"
export * from "./SavedQueriesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports